export default __webpack_public_path__ + "static/media/v9.fc53eb5d.jpg";